import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "../theme";
import { Icon } from "../icon";
export const DropdownMenuDots = ({ className, disabled, testId }) => (_jsx(Container, { className: className, disabled: disabled, "data-test-id": testId, children: _jsx(StyledIcon, { name: "dots", size: 17, disabled: disabled }) }));
DropdownMenuDots.defaultProps = {
    disabled: false,
    testId: undefined,
};
const StyledIcon = styled(Icon) `
  transform: translate(0.5px, 0.5px);
  ${({ disabled, theme }) => disabled && `color: ${theme.color.borderLightGray}`}
`;
const Container = styled.span `
  display: inline-flex;
  align-items: center;
  border: 1px solid
    ${({ theme, disabled }) => disabled ? theme.color.borderLightGray : theme.color.gray100};
  border-radius: 15px;
  padding: 0 5px;
  color: ${({ theme }) => theme.color.darkBlue100};
  cursor: pointer;
`;
